import { deepMerge } from 'utils/helpers';
import { numberOfColumns } from './dashboardUtils';
import * as t from './visualizationTypes';

export const visualizations = [t.AREA, t.BAR, t.COLUMN, t.LINE, t.NUMBER, t.SPLINE].map(
  (viz) => viz.name,
);

/**
 * visualizationDef
 * Object definition of the visualization types.
 * { 'all': ALL {}, 'bar': BAR {} ... }
 */
export const visualizationDef = Object.keys(t).reduce((obj, id) => {
  const newObj = obj;
  newObj[t[id].name.toLowerCase()] = t[id];
  return newObj;
}, {});

/**
 * getVisualizationsForMetric
 * Returns the list of available visualizations for a metric.
 * @param { Object } metricDef: The metric object containing displayType, enumName and name.
 * @returns { Array } List of visualizations for the given metric.
 */
export const getVisualizationsForMetric = (metricDef) => {
  if (metricDef && metricDef.displayType) {
    if (metricDef.displayType === 'percentage') {
      return t.PERCENTAGE_ALL.list.map((viz) => viz.name);
    }
    return t.NUMBER_ALL.list.map((viz) => viz.name);
  }
  return [];
};

/**
 * getWidgetSettingsForVisualization
 * Get a basic config for a particular visualization (chart type) (Mainly DashboardPanel dimensions).
 * @param { String } vizType: The type of visualization (chart type).
 * @param { Boolean } wideWidget: Initial widget is wide.
 * @returns { Object } Config object for widget.
 */
export const getWidgetSettingsForVisualization = (vizType = t.LINE.name, wideWidget) => {
  /** The visualization type object. */
  const visualization = visualizationDef[vizType.toLowerCase()] || visualizationDef[t.LINE.name];
  /** Base config for all widgets. */
  const baseWidgetConfig = {
    minH: 2,
    minW: 2,
    w: wideWidget ? 4 : 2,
    h: 2,
    x: wideWidget ? 8 : 10,
    y: Infinity,
    maxW: numberOfColumns,
    settings: {
      visualization: vizType,
    },
    settingsList: visualization.settingsList,
  };
  return deepMerge({}, baseWidgetConfig, { settings: visualization.getSettings() });
};
